/* ASC-CUSTOM (Atelier design demo, 2026-09-23): small helpers for the guided occasion page (sections/asc-at-occasion.liquid).
   The chip filtering itself is asc-atelier.js ([data-at-chips]); this file only
   - lets a "what are you looking for?" coin open its chip ([data-oc-go] = the chip's data-at-filter) and scroll to the grid,
   - keeps the pressed chip in view inside the horizontal chip row on phones,
   - announces how many pieces are shown ([data-oc-count], polite live region). No dependencies. */
(function () {
  'use strict';
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function announce(bar) {
    var root = bar.closest('[data-oc]') || document;
    var out = root.querySelector('[data-oc-count]');
    var grid = document.getElementById(bar.getAttribute('data-at-chips'));
    if (!out || !grid) return;
    var n = grid.querySelectorAll('[data-at-tags]:not([hidden])').length;
    out.textContent = n === 1 ? 'Showing 1 piece' : 'Showing ' + n + ' pieces';
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-oc-chipbar] [data-at-filter]');
    if (chip) {
      var bar = chip.closest('[data-oc-chipbar]');
      setTimeout(function () { announce(bar); }, 0);
      if (bar.scrollWidth > bar.clientWidth) {
        var left = chip.offsetLeft - (bar.clientWidth - chip.offsetWidth) / 2;
        try { bar.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' }); } catch (err) { bar.scrollLeft = left; }
      }
      return;
    }
    var go = e.target.closest && e.target.closest('[data-oc-go]');
    if (!go) return;
    var key = go.getAttribute('data-oc-go');
    var target = document.querySelector('[data-oc-chipbar] [data-at-filter="' + key + '"]');
    if (!target) return;
    e.preventDefault();
    target.click();
    var sec = document.getElementById((go.getAttribute('href') || '').replace('#', ''));
    if (sec) sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    try { target.focus({ preventScroll: true }); } catch (err) {}
  });
})();
